import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    photos: null,
    background: null,
    user: null
  },
  mutations: {
    setPhotos(state, photos) {
      state.photos = photos
    },
    setBackground(state, url) {
      state.background = url
    },
    setUser(state, user) {
      state.user = user
    }
  },
  actions: {
    async setPhotos(context, isMobile) {
      const params = {
        method: "GET",
      };
      console.log(isMobile)
      let photosetId = isMobile ? "72157716939051887" : "72157716663110253";
      let url = "https://www.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=cc997bf7c96464956df60a3d82c19f2b&photoset_id=" + photosetId + "&user_id=113327493@N05&format=json&nojsoncallback=1";
      let response = await fetch(url, params);
      let body = await response.json();
      body.photoset.photo.forEach(el => el.src = "https://live.staticflickr.com/" + el.server + "/" + el.id + "_" + el.secret + "_o.jpg");
      if (body.stat === "ok") {
        context.commit('setPhotos', body.photoset.photo)
        return true;
      } else {
        context.commit('setPhotos', new Array());
        return false;
      }
    },
    async setBackground(context, id, isMobile) {
      const params = {
        method: "GET",
      };
      let url = "https://www.flickr.com/services/rest/?method=flickr.photos.getSizes&api_key=cc997bf7c96464956df60a3d82c19f2b&photo_id=" + id + "&format=json&nojsoncallback=1";
      let response = await fetch(url, params);
      let body = await response.json();
      if (body.stat === "ok") {
        let pictureSize = isMobile ? "Medium" : "Large"
        let src = body.sizes.size.find(el => el.label === pictureSize).source
        context.commit('setBackground', src)
        return true;
      } else {
        return false;
      }
    }
  },
  modules: {
  }
})
